const state = () => ({
  queryData: null
});

const getters = {
  queryData(state) {
    return state.queryData;
  }
};

const mutations = {
  setQueryData(state, payload) {
    state.queryData = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  setQueryData({ commit }, payload) {
    commit('setQueryData', payload);
  }
};

export const aeskulab = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
